import React from "react";

// Empty checkbox (unselected).
export const CheckboxUncheckedIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.46191 0.577148H11.5381C13.1312 0.577148 14.4229 1.86879 14.4229 3.46191V11.5381C14.4229 13.1312 13.1312 14.4229 11.5381 14.4229H3.46191C1.86879 14.4229 0.577148 13.1312 0.577148 11.5381V3.46191C0.577148 1.86879 1.86879 0.577148 3.46191 0.577148Z"
      stroke="black"
      strokeOpacity="0.34"
      strokeWidth="1.15385"
    />
  </svg>
);

// Checked checkbox (green box + white tick). The original SVG's <mask> layers
// were full-area no-ops, so they're dropped to avoid duplicate-id issues.
export const CheckboxCheckedIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 3.46154C0 1.54978 1.54978 0 3.46154 0H11.5385C13.4502 0 15 1.54978 15 3.46154V11.5385C15 13.4502 13.4502 15 11.5385 15H3.46154C1.54978 15 0 13.4502 0 11.5385V3.46154Z"
      fill="#458764"
    />
    <path
      d="M6.33507 8.61595L10.0727 4.87831C10.1888 4.76217 10.3367 4.7041 10.5162 4.7041C10.6956 4.7041 10.8435 4.76217 10.9596 4.87831C11.0757 4.99445 11.1338 5.14227 11.1338 5.32176C11.1338 5.50125 11.0757 5.64907 10.9596 5.76521L6.77852 9.9463C6.65182 10.073 6.504 10.1363 6.33507 10.1363C6.16614 10.1363 6.01832 10.073 5.89162 9.9463L4.24452 8.2992C4.12838 8.18306 4.07031 8.03524 4.07031 7.85575C4.07031 7.67626 4.12838 7.52845 4.24452 7.41231C4.36067 7.29616 4.50848 7.23809 4.68797 7.23809C4.86746 7.23809 5.01528 7.29616 5.13142 7.41231L6.33507 8.61595Z"
      fill="white"
    />
  </svg>
);

// Knowledge-base folder icon.
export const FolderIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none" className="flex-shrink-0">
    <path
      d="M1.45833 12.5C1.05347 12.5 0.709167 12.3582 0.425417 12.0746C0.141806 11.7908 0 11.4465 0 11.0417V1.50646C0 1.1016 0.149861 0.749306 0.449583 0.449584C0.749306 0.149861 1.1016 0 1.50646 0H5.45833C5.65917 0 5.85229 0.0390277 6.03771 0.117083C6.22299 0.195 6.38403 0.302361 6.52083 0.439167L7.74833 1.66667H15.1363C15.3136 1.66667 15.4621 1.72653 15.5817 1.84625C15.7014 1.96583 15.7613 2.11431 15.7613 2.29167C15.7613 2.46903 15.7014 2.6175 15.5817 2.73708C15.4621 2.85681 15.3136 2.91667 15.1363 2.91667H4.29C3.47167 2.91667 2.76042 3.17681 2.15625 3.69708C1.55208 4.21736 1.25 4.87549 1.25 5.67146V10.9935C1.25 11.0523 1.26472 11.1003 1.29417 11.1377C1.32347 11.1752 1.36215 11.2073 1.41021 11.234L3.03208 5.81896C3.1325 5.49521 3.31729 5.23507 3.58646 5.03854C3.85576 4.84187 4.15493 4.74354 4.48396 4.74354H15.2019C15.7126 4.74354 16.1178 4.94653 16.4175 5.3525C16.7171 5.75847 16.7958 6.20132 16.6538 6.68104L15.2179 11.4648C15.1228 11.7777 14.9447 12.0285 14.6835 12.2171C14.4223 12.4057 14.1325 12.5 13.8142 12.5H1.45833Z"
      fill="#E6C12E"
    />
  </svg>
);
